export enum InstallmentPlanTypeEnum {
  Manual = "Manual",
  Automatic = "Automatic",
  Pending = "Pending",
  Registered = "Registered",
}
